<div class="img-container">
    <div (click)="fileElement.click()">
        <ng-content select=".app-file-uploader-button"></ng-content>
    </div>
    <div class="cropper" [ngClass]="!showCropper ? 'hidden':''">
        <ng-content select=".app-file-uploader-input"></ng-content>
        <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="true"
                [roundCropper]="settings.roundCropper"
                [resizeToWidth]="settings.resizeToWidth"
                [aspectRatio]="settings.ratio"
                [onlyScaleDown]="true"
                [containWithinAspectRatio]='false'
                [imageQuality]="80"
                [transform]="transform"
                format="jpeg"
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded()"
                (loadImageFailed)="loadImageFailed()"
                (click)="disableClick()"
                alignImage="center"
        ></image-cropper>

        <ng-content select=".app-file-uploader-sizes"></ng-content>

        <div *ngIf="hasFooter" class="btn-block">
            <app-secondary-button className="medium mr-1" (onClick)="hideCropper()" text="{{'cancel' | translate}}">
            </app-secondary-button>
            <app-primary-button className="medium" (onClick)="confirmChangeForImage()" text="{{'crop' | translate}}">
            </app-primary-button>
        </div>
    </div>
    <input type="file" id="fileElem" #fileElement accept="image/x-png,image/gif,image/jpeg"
           (change)="fileChangeEvent($event)">
</div>
